export default __webpack_public_path__ + "static/media/modelxx.67055759.jpg";